module.exports = __webpack_public_path__ + "static/img/Bachelor_010810.b599322.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010810.jpg
// module id = 254
// module chunks = 0